import { Pressable, View, StyleSheet, StyleProp, ViewStyle } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";

const SIZES = { small: 16, medium: 20, large: 24 };

export interface RadioButtonProps {
  label: string;
  selected?: boolean;
  onPress?: () => void;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
  style?: StyleProp<ViewStyle>;
}

export function RadioButton({
  label,
  selected = false,
  onPress,
  disabled = false,
  size = "medium",
  style,
}: RadioButtonProps) {
  const { colors } = useTheme();
  const circleSize = SIZES[size];
  const innerSize = circleSize * 0.5;

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      style={({ pressed, hovered }) =>
        [
          styles.container,
          hovered && { opacity: 0.8 },
          pressed && { opacity: 0.6 },
          disabled && { opacity: 0.5 },
          style,
        ] as any
      }
    >
      <View
        style={[
          styles.outer,
          {
            width: circleSize,
            height: circleSize,
            borderRadius: circleSize / 2,
            borderColor: selected ? colors.primary : colors.border,
          },
        ]}
      >
        {selected && (
          <View
            style={[
              styles.inner,
              {
                width: innerSize,
                height: innerSize,
                borderRadius: innerSize / 2,
                backgroundColor: colors.primary,
              },
            ]}
          />
        )}
      </View>
      <ThemedText style={styles.label}>{label}</ThemedText>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
  } as any,
  outer: {
    borderWidth: 2,
    alignItems: "center",
    justifyContent: "center",
  },
  inner: {},
  label: {
    fontSize: 14,
  },
});
